/**
 * **プレビューの軽さの設定**（`/duel-timing` と `/duel-editor`）。舞台の設定（`config.stage`）に混ぜるだけ。
 *
 * 重いのは主に 3 つ: three の層（盤・オブジェクト・演出・手前の演出）が**それぞれ 1920×1080 を描く**こと、
 * 盤の紙（元動画を毎フレーム描いてテクスチャに上げる。長辺 2048）、演出の層の後処理（光のにじみ）。
 * 画面ではその 1/3 ほどに縮めて見ているので、プレビューでは描くピクセルを減らしても見た目はほぼ変わらない。
 *
 * - `renderScale` … three の描き先の解像度の倍率（`runtime.setQuality`。座標・カメラは変わらない）
 * - `resolution`  … 盤の紙の長辺（`FieldLayer`）
 * - `noPost`      … 光のにじみ・色収差を切る（画面を切る演出は中身なので残す）
 *
 * **書き出し（render モード）には使わない**（常に「高」）。
 */
export const PREVIEW_QUALITIES = Object.freeze([
  { id: 'high', label: '高（書き出しと同じ）', stage: {} },
  { id: 'medium', label: '中（解像度 3/4）', stage: { renderScale: 0.75, resolution: 1536 } },
  { id: 'low', label: '低（解像度 1/2・光のにじみなし）', stage: { renderScale: 0.5, resolution: 1024, noPost: true } },
]);

/** プレビューの舞台の高さ（px。幅は 16:9 で決まる。Issue #643） */
export const STAGE_HEIGHT = Object.freeze({ min: 240, max: 1080, step: 20, def: 600 });

export const DEFAULT_PREVIEW = Object.freeze({ quality: 'high', fps: false, stageHeight: STAGE_HEIGHT.def });

/** 舞台の高さを範囲に収める */
export const clampStageHeight = (v) => (Number.isFinite(v) ? Math.min(STAGE_HEIGHT.max, Math.max(STAGE_HEIGHT.min, Math.round(v))) : STAGE_HEIGHT.def);

const KEY = 'duelEditor.preview.v1';

export const qualityById = (id) => PREVIEW_QUALITIES.find((q) => q.id === id) ?? PREVIEW_QUALITIES[0];

/** 端末ごとの好み（localStorage。読めなければ既定） */
export function loadPreviewPrefs() {
  try {
    const v = JSON.parse(window.localStorage.getItem(KEY) ?? 'null');
    const out = { ...DEFAULT_PREVIEW, ...(v && typeof v === 'object' ? v : {}) };
    return { ...out, stageHeight: clampStageHeight(out.stageHeight) };
  } catch (e) {
    return { ...DEFAULT_PREVIEW };
  }
}

export function savePreviewPrefs(prefs) {
  try { window.localStorage.setItem(KEY, JSON.stringify(prefs)); } catch (e) { /* 保存できなくても使える */ }
}
